import { isEnglishLanguage } from 'common/utils/date';
import dayjs from 'dayjs';
import 'dayjs/locale/th';

// B.E. with Thai month names, or C.E. with English month names in English.
const localized = (d: string | Date) => dayjs(d).locale(isEnglishLanguage() ? 'en' : 'th');
const year2 = (m: dayjs.Dayjs) => (isEnglishLanguage() ? m.year() : m.year() + 543) % 100;

export function formatThaiShortBE(d: string | Date) {
  const m = localized(d);
  return `${m.format('D MMM')} ${String(year2(m)).padStart(2, '0')}`;
}

export function formatThaiShortBEWithTime(d: string | Date) {
  const m = localized(d);
  return `${m.format('DD MMM')} ${String(year2(m)).padStart(2, '0')} ${m.format('HH:mm')}`;
}
